import { render, staticRenderFns } from "./Third.vue?vue&type=template&id=0005d188&"
import script from "./Third.vue?vue&type=script&lang=ts&"
export * from "./Third.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports